import { createAction } from "redux-actions";
import { apiGet } from "../../../api/index";
import { urlFarmsSecured } from "../../../api/urls";

const generateFilterQuery = (filters) => {
  let filter = "?";
  if (filters) {
    if (filters?.name !== undefined) filter += "&name=" + filters?.name;
  }
  //if (sort) filter += "&sort=" + sort;
  return filter;
};

export const getAll = createAction("GET_FARMS", (filter, param) =>
  apiGet(urlFarmsSecured + generateFilterQuery(filter), param, false)()
);
